angular.module('hcap-analytics')
  .service('PortalsService', ['$http', '$q', function($http, $q) {
    let portals = null;

    this.getAll = function(force) {
      if (portals && !force) {
        return $q.resolve(_.cloneDeep(portals));
      }

      return $http.get('./api/portals').then(res => {
        portals = res.data;
        return _.cloneDeep(portals);
      });
    };

    this.get = function(slug) {
      return $http.get('./api/portals/' + encodeURIComponent(slug)).then(res => res.data);
    };
  }]);
